import InfinityScroll from '../components/infinityScroll';
import { updatePriceBlock } from '../components/utilities.js';

let isMobile = false;

if (window.screen.width >= 1023) {
  isMobile = false;
} else {
  isMobile = true;
}

const Tag = {
  spotGrid: function () {
    if (isMobile == false) {
      const setGridAttributesNode = () => {
        let filterGridNode = `<div class="filter__grid">
                                        <span class="grid__title">Visualização</span>
                                    
                                        <ul class="grid__wrapper">
                                          <li data-grid="2">
                                            <i></i>
                                            <i></i>
                                          </li>
                                          <li data-grid="3">
                                            <i></i>
                                            <i></i>
                                            <i></i>
                                          </li>
                                  
                                          <li class="active" data-grid="4">
                                            <i></i>
                                            <i></i>
                                            <i></i>
                                            <i></i>
                                          </li>
                                        </ul>
                                    </div>`;

        if (document.querySelector('.page__category .category__filter')) {
          document.querySelector('.page__category .category__filter .category__inner').insertAdjacentHTML("beforeend", filterGridNode);
        }
      }
      setGridAttributesNode();

      const setGridReady = () => {
        let gridItems = document.querySelectorAll('.page__category .filter__grid ul li');
        let spots = document.querySelectorAll('.page__category .category__spots .product-block');

        gridItems.forEach(item => {
          let dataGrid;

          if (item.classList.contains('active')) {
            dataGrid = item.getAttribute('data-grid');
          }

          if (spots.length == 3) dataGrid = 3
          else if (spots.length == 2) dataGrid = 2

          spots.forEach(spot => {
            spot.setAttribute('data-grid', dataGrid);
          });
        });
      }
      setGridReady();

      const selectGridNumber = () => {
        let gridItems = document.querySelectorAll('.page__category .filter__grid ul li');
        let spots = document.querySelectorAll('.page__category .category__spots .product-block');

        gridItems.forEach(item => {
          item.addEventListener('click', (event) => {
            let dataGrid = event.currentTarget.getAttribute('data-grid');

            // Remove all class "active" which has
            gridItems.forEach(itemOuter => {
              itemOuter.classList.remove('active');
            });

            // Add class "active" on current item by click
            item.classList.add('active');

            spots.forEach(spot => {
              spot.setAttribute('data-grid', dataGrid);
            });
          });
        });

        const FourItensPerView = document.querySelector('[data-grid="4"]');
        FourItensPerView && FourItensPerView.click();
      }
      selectGridNumber();
    }
  },

  init: function () {
    updatePriceBlock();

    InfinityScroll.init();

    Tag.spotGrid();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Tag.init()
})
